import React from 'react'
import ItemPrint from './ItemPrint'

const ContainerPrint = ({ containers, fullNameInContainer }) => {
  return (
    <div className="container-print-container">
      <div className="container-print-content">
        {Object.entries(containers).map(([listName, listItems], indexList) => {
          if (listName === 'listItemLefts' || listName === 'listItemRights') {
            return (
              <div key={indexList}>
                <div className="container-print-grid">
                  <div>No</div>
                  <div>ชุดที่ / หมายเลข</div>
                </div>
                {listItems.map((item, indexItem) => {
                  return <ItemPrint key={indexItem} item={item} />
                })}
              </div>
            )
          } else {
            return null
          }
        })}
      </div>
      <div className="full-name-in-container">
        <span>ลงชื่อ {fullNameInContainer}</span>
        <span>จำนวน {containers.countPrize} ใบ</span>
      </div>
    </div>
  )
}

export default ContainerPrint
